<template>
  <span>
    <navbar-menu-tool
      v-model="isMenuOpen"
      :menu-data="{ name: 'uldk', position: 'top', allowOtherLeft: true }"
      :button-bind="{ icon, tooltip }"
      :loading="loading"
    >
      <template #content>
        <v-row no-gutters class="px-5 tw:pt-1" align="center" v-if="databoxEnabled">
          <v-col cols="auto">
            <v-tooltip bottom color="font">
              <template #activator="{ on }">
                <span v-on="on">
                  <v-radio-group
                    class="my-0 py-0 input--type"
                    v-model="mode"
                    dense
                    row
                    hide-details
                    :readonly="loading"
                    @change="onModeChange"
                  >
                    <v-radio label="Data.Box" value="databox" :ripple="false">
                      <template #label>
                        <span class="font--text text-body-2 tw:pt-0.5" style="font-size: 12px !important">
                          Data.Box
                        </span>
                      </template>
                    </v-radio>
                    <v-radio label="ULDK" value="uldk" :ripple="false">
                      <template #label>
                        <span class="font--text text-body-2 tw:pt-0.5" style="font-size: 12px !important"> ULDK </span>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </span>
              </template>
              {{ $i18n.t('sidebar.uldk.searchEnginge') }}
            </v-tooltip>
          </v-col>
          <v-col cols="auto" v-if="mode === 'uldk'">
            <base-button type="alternative" size="sm" @click="toggleMultipleSearch">
              {{ $i18n.t('sidebar.uldk.multipleSearch') }}
            </base-button>
          </v-col>
          <v-col cols="auto" class="pl-2">
            <data-input ref="geometry-input" v-bind="localizationPointInput" v-model="localizationPointGeometry">
              <template #button="{ activeType }">
                <base-button
                  type="alternative"
                  size="sm"
                  icon="$addLocation"
                  :toggled="!!activeType"
                  :tooltip="$i18n.t('sidebar.uldk.getLocalizationByMap')"
                  v-on="getLocalizationListeners()"
                />
              </template>
            </data-input>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          class="px-5"
          :class="{ 'pb-2': !computedResultList?.length, 'pt-5': !databoxEnabled }"
          justify="center"
        >
          <v-col cols="auto" style="width: calc(100% - 36px)" :class="{ 'uldk-inputs-databox': databoxEnabled }">
            <v-form ref="form" v-model="isValid">
              <v-row no-gutters>
                <v-col v-for="(input, idx) of inputs" :key="idx" :cols="12 / inputs.length" class="px-1">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <template v-if="input.name === 'parcelTerrit'">
                        <data-input v-bind="input" v-model="parcelTerrit" v-on="input.listeners" />
                      </template>
                      <template v-else>
                        <data-input v-bind="input" v-model="params[input.name]" v-on="input.listeners" />
                      </template>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="text-left font-italic font-weight-light" style="font-size: 12px">
                    <template v-if="input.name === 'precinct'">
                      <v-checkbox
                        v-model="params['precinctNotKnown']"
                        @change="updateParcelTerrit"
                        class="pa-0 ma-0"
                        :label="$i18n.t('sidebar.uldk.precinctNotKnown')"
                        :readonly="loading"
                      />
                    </template>
                    <template v-else-if="input.subtitle">
                      <span class="pt-1"> {{ input.subtitle }} </span>
                    </template>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="auto" style="max-width: 36px" class="pl-1 pt-1" :class="{ 'tw:pt-2.5': databoxEnabled }">
            <base-button icon="mdi-magnify" :disabled="computedDisabled" @click="search()" />
          </v-col>
        </v-row>
        <v-row no-gutters class="pl-6 pr-5 pb-2" align="center" justify="center">
          <template v-if="computedResultList?.length">
            <v-col cols="auto" style="font-size: 12px !important">
              {{ `${$i18n.t('sidebar.uldk.searchResult')}: ${computedResultList.length}` }}
            </v-col>
            <v-col cols="auto" style="width: 225px" class="pl-2">
              <data-input v-bind="resultListInput" v-model="currentResult" class="navbar-uldk-result-select" />
            </v-col>
            <v-col cols="auto" class="pl-2">
              <base-button
                type="text"
                size="sm"
                icon="mdi-magnify"
                color="primary"
                :disabled="!currentResult"
                @click="addParcel()"
              />
            </v-col>
          </template>
          <v-spacer />
          <v-col
            v-if="hasParcelsOnMap || computedResultList?.length"
            cols="auto"
            :style="computedResultList?.length ? '' : 'position: relative; top: -7px !important'"
          >
            <base-button type="text" color="error" size="sm" icon="mdi-cancel" @click="clear()">
              {{ $i18n.t('sidebar.uldk.clearResult') }}
            </base-button>
          </v-col>
        </v-row>
      </template>
    </navbar-menu-tool>
    <parcels-search-menu-tool v-model="multipleSearchVisible" />
  </span>
</template>
<script>
import { call, get } from 'vuex-pathify';

import DataInput from '@/components/DataInput';
import NavbarMenuTool from '@/components/NavbarMenuTool';
import ParcelsSearchMenuTool from '@/components/ParcelsSearchMenuTool';

export default {
  name: 'TheNavbarToolsPanelUldk',
  components: { DataInput, NavbarMenuTool, ParcelsSearchMenuTool },
  props: {
    icon: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
    },
    fontSize: {
      type: String,
      default: '19px',
    },
  },
  computed: {
    localizationPointInput() {
      return {
        dataType: { name: 'geometry' },
        name: 'locationAnalysisGeometry',
        disabled: this.loading,
      };
    },
    databoxEnabled: get('admin/additionalModules@DATABOX_DATA_MODULE.enabled'),
    inputs() {
      const defaultProps = {
        hideDetails: true,
      };
      return [
        {
          name: 'voivodeship',
          label: `${this.$i18n.t('sidebar.uldk.voivodeship')}*`,
          dataType: { name: 'select' },
          loading: this.admnistrativeParamsItemsLoading.voivodeship,
          readonly: this.admnistrativeParamsItemsLoading.voivodeship || this.loading,
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['voivodeship']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territId}` };
          }),
          itemText: 'text',
          itemValue: 'territId',
          returnObject: true,
          rules: [this.rules.required],
          listeners: {
            change: this.getDistricts,
          },
          ...defaultProps,
        },
        {
          name: 'district',
          label: `${this.$i18n.t('sidebar.uldk.district')}*`,
          dataType: { name: 'select' },
          loading: this.admnistrativeParamsItemsLoading.district,
          readonly: this.admnistrativeParamsItemsLoading.district || this.loading,
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['district']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territId}` };
          }),
          itemText: 'text',
          itemValue: 'territId',
          returnObject: true,
          rules: [this.rules.required],
          disabled: !this.params['voivodeship'],
          listeners: {
            change: this.getCommunities,
          },
          ...defaultProps,
        },
        {
          name: 'community',
          label: `${this.$i18n.t('sidebar.uldk.community')}*`,
          dataType: { name: 'select' },
          loading: this.admnistrativeParamsItemsLoading.community,
          readonly: this.admnistrativeParamsItemsLoading.community || this.loading,
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['community']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territIdWithType}`, value: item.territId };
          }),
          itemText: 'text',
          itemValue: 'territId',
          returnObject: true,
          rules: [this.rules.required],
          disabled: !this.params['district'],
          listeners: {
            change: this.getPrecincts,
          },
          ...defaultProps,
        },
        {
          name: 'precinct',
          label: `${this.$i18n.t('sidebar.uldk.precinct')}${this.params.precinctNotKnown ? '' : '*'}`,
          dataType: { name: 'select' },
          loading: this.admnistrativeParamsItemsLoading.precinct,
          readonly: this.admnistrativeParamsItemsLoading.precinct || this.loading,
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['precinct']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territId}` };
          }),
          itemText: 'text',
          itemValue: 'territId',
          returnObject: true,
          rules: this.params.precinctNotKnown ? [] : [this.rules.required],
          disabled: this.params.precinctNotKnown || !this.params['community'],
          listeners: {
            change: this.updateParcelTerrit,
          },
          ...defaultProps,
        },
        {
          name: 'parcelId',
          label: `${this.$i18n.t('sidebar.uldk.parcelId')}*`,
          subtitle: this.$i18n.t('sidebar.uldk.parcelIdSubtitle2'),
          dataType: { name: 'text' },
          readonly: this.loading,
          disabled: !this.params['precinct'] && !this.params['precinctNotKnown'],
          rules: [this.rules.required],
          listeners: {
            input: this.updateParcelTerrit,
          },
          ...defaultProps,
        },
        {
          name: 'parcelTerrit',
          label: this.$i18n.t('sidebar.uldk.parcelTerrit'),
          subtitle: this.$i18n.t('sidebar.uldk.parcelTerritSubtitle2'),
          dataType: { name: 'text' },
          readonly: this.loading,
          rules: [this.rules.parcelTerrit],
          listeners: {
            change: this.changeParcelTerrit,
          },
          ...defaultProps,
        },
      ];
    },
    resultListInput() {
      return {
        dataType: { name: 'select' },
        hideDetails: true,
        items: this.computedResultList,
        returnObject: true,
      };
    },
    rules() {
      return {
        required: v => !!v || this.$i18n.t('rules.required'),
        parcelTerrit: () => {
          return (
            this.isParcelTerritValid.valid || this.$i18n.t(`sidebar.uldk.${this.isParcelTerritValid.error}BadTerrit`)
          );
        },
      };
    },
    computedResultList() {
      return this.resultList.map(result => {
        const parcelTerrit = result.properties.id_dzialki;
        const computedResult = {
          parcelId: result.properties.numer || result.properties.name,
          parcelTerrit: parcelTerrit || result.properties.name,
          geometry: result.geometry,
        };
        if (parcelTerrit) {
          const dotsIndexes = [];
          for (let i = 0; i < parcelTerrit.length; i++) {
            if (parcelTerrit[i] === '.') {
              dotsIndexes.push(i);
            }
          }
          const numberOfDots = dotsIndexes.length;
          computedResult.precinct = parcelTerrit.substr(dotsIndexes[0] + 1, 4);
          if (numberOfDots > 2) {
            computedResult.mapSheet = parcelTerrit.substring(dotsIndexes[1] + 1, dotsIndexes[2]);
          }
        }
        computedResult.text = `${computedResult.parcelId} ${
          parcelTerrit
            ? `(${this.$_loweralize(this.$i18n.t('sidebar.uldk.precinct'))}: ${computedResult.precinct}${
                computedResult.mapSheet
                  ? `, ${this.$_loweralize(this.$i18n.t('sidebar.uldk.sheet'))}: ${computedResult.mapSheet}`
                  : ''
              })`
            : ''
        }`;
        return computedResult;
      });
    },
    computedDisabled() {
      return this.loading || !this.isParcelTerritValid.valid;
    },
  },
  data: () => ({
    localizationPointGeometry: null,
    isMenuOpen: false,
    menuOpenWatch: undefined,
    admnistrativeParamsItems: {
      voivodeship: [],
      district: [],
      community: [],
      precinct: [],
    },
    admnistrativeParamsItemsLoading: {
      voivodeship: false,
      district: false,
      community: false,
      precinct: false,
    },
    isParcelTerritValid: { valid: true },
    isValid: false,
    loading: false,
    params: {},
    parcelTerrit: '',
    resultList: [],
    currentResult: undefined,
    mode: '',
    modsGeometryTypeDict: {
      uldk: 'wkt',
      databox: 'geojson',
    },
    hasParcelsOnMap: false,
    multipleSearchVisible: false,
  }),
  methods: {
    onModeChange(value) {
      localStorage.setItem('uldk2Mode', value);
      this.init(true);
    },
    getDataboxCommunities: call('search/getDataboxCommunities'),
    getUldkCommunities: call('search/getUldkCommunities'),
    getDataboxDistricts: call('search/getDataboxDistricts'),
    getUldkDistricts: call('search/getUldkDistricts'),
    getDataboxPrecincts: call('search/getDataboxPrecincts'),
    getUldkPrecincts: call('search/getUldkPrecincts'),
    getDataboxVoivodeships: call('search/getDataboxVoivodeships'),
    getUldkVoivodeships: call('search/getUldkVoivodeships'),
    getDataboxCommunity: call('search/getDataboxCommunity'),
    getUldkCommunity: call('search/getUldkCommunity'),
    getDataboxDistrict: call('search/getDataboxDistrict'),
    getUldkDistrict: call('search/getUldkDistrict'),
    getDataboxPrecinct: call('search/getDataboxPrecinct'),
    getUldkPrecinct: call('search/getUldkPrecinct'),
    getDataboxVoivodeship: call('search/getDataboxVoivodeship'),
    getUldkVoivodeship: call('search/getUldkVoivodeship'),
    searchDataboxParcel: call('search/searchDataboxParcel'),
    searchDataboxParcelByXY: call('search/searchDataboxParcelByXY'),
    searchUldkParcel: call('search/searchUldkParcel'),
    searchUldkParcelByXY: call('search/searchUldkParcelByXY'),
    async getVoivodeships() {
      this.admnistrativeParamsItemsLoading.voivodeship = true;
      try {
        const r = await this[`get${this.$_capitalize(this.mode)}Voivodeships`]();
        this.admnistrativeParamsItems.voivodeship = r;
        this.$refs.form?.resetValidation();
      } finally {
        this.admnistrativeParamsItemsLoading.voivodeship = false;
      }
    },
    async getDistricts(nV, updateParcelTerrit = true, resetValidation = true, skipParamsClear = false) {
      if (!skipParamsClear) {
        this.params = { ...this.params, district: '', community: '', precinct: '' };
      }
      if (resetValidation) {
        this.$refs.form?.resetValidation();
      }
      if (updateParcelTerrit) {
        this.updateParcelTerrit();
      }
      this.admnistrativeParamsItemsLoading.district = true;
      try {
        const r = await this[`get${this.$_capitalize(this.mode)}Districts`]({ voivodeship: nV.territId });
        this.admnistrativeParamsItems.district = r;
      } finally {
        this.admnistrativeParamsItemsLoading.district = false;
      }
    },
    async getCommunities(nV, updateParcelTerrit = true, resetValidation = true, skipParamsClear = false) {
      if (!skipParamsClear) {
        this.params = { ...this.params, community: '', precinct: '' };
      }
      if (resetValidation) {
        this.$refs.form?.resetValidation();
      }
      if (updateParcelTerrit) {
        this.updateParcelTerrit();
      }
      this.admnistrativeParamsItemsLoading.community = true;
      try {
        const r = await this[`get${this.$_capitalize(this.mode)}Communities`]({
          district: nV.territId,
          fixTerrit: true,
        });
        this.admnistrativeParamsItems.community = r;
      } finally {
        this.admnistrativeParamsItemsLoading.community = false;
      }
    },
    async getPrecincts(nV, updateParcelTerrit = true, resetValidation = true, skipParamsClear = false) {
      if (!skipParamsClear) {
        this.params = { ...this.params, precinct: '' };
      }
      if (resetValidation) {
        this.$refs.form?.resetValidation();
      }
      if (updateParcelTerrit) {
        this.updateParcelTerrit();
      }
      this.admnistrativeParamsItemsLoading.precinct = true;
      try {
        let r = {};
        r = await this[`get${this.$_capitalize(this.mode)}Precincts`]({ community: nV.territId });
        if (!r || !Object.keys(r)?.length)
          r = await this[`get${this.$_capitalize(this.mode)}Precincts`]({ community: nV.territIdWithType });
        this.admnistrativeParamsItems.precinct = r;
      } finally {
        this.admnistrativeParamsItemsLoading.precinct = false;
      }
    },
    async changeParcelTerrit(nV = '') {
      if (nV.length >= 2) {
        const voivodeshipTerrit = nV.substring(0, 2);
        const voivodeship = this.admnistrativeParamsItems.voivodeship[voivodeshipTerrit];
        if (!voivodeship) {
          this.isParcelTerritValid = { valid: false, error: 'voivodeship' };
          this.$refs.form?.resetValidation();
          return;
        }
        this.params.voivodeship = voivodeship;
        this.$refs.form?.resetValidation();
        await this.getDistricts(voivodeship, false, false);
      }
      if (nV.length >= 4) {
        const districtTerrit = nV.substring(0, 4);
        const district = this.admnistrativeParamsItems.district[districtTerrit];
        if (!district) {
          this.isParcelTerritValid = { valid: false, error: 'district' };
          this.$refs.form?.resetValidation();
          return;
        }
        this.params.district = district;
        this.$refs.form?.resetValidation();
        await this.getCommunities(district, false, false);
      }
      if (nV.length >= 8) {
        const communityTerrit = nV.substring(0, 6);
        const community = this.admnistrativeParamsItems.community[communityTerrit];
        if (!community) {
          this.isParcelTerritValid = { valid: false, error: 'community' };
          this.$refs.form?.resetValidation();
          return;
        }
        this.params.community = community;
        this.$refs.form?.resetValidation();
        await this.getPrecincts(community, false, false);
      }
      if (nV.length >= 10 && nV.substring(8, 10) === '.?') {
        const precinctNotKnown = true;
        this.params = { ...this.params, precinctNotKnown };
        this.$refs.form?.resetValidation();
      } else if (nV.length >= 13) {
        const precinctTerrit = nV.substring(0, 13);
        const precinct = this.admnistrativeParamsItems.precinct[precinctTerrit];
        if (!precinct) {
          this.isParcelTerritValid = { valid: false, error: 'precinct' };
          this.$refs.form?.resetValidation();
          return;
        }
        const precinctNotKnown = false;
        this.params = { ...this.params, precinct, precinctNotKnown };
      }
      this.params.parcelId = '';
      if (nV.length >= 12 && nV.substring(8, 10) === '.?' && nV[10] === '.') {
        this.params.parcelId = nV.substr(11, nV.length);
      } else if (nV.length >= 15 && nV[13] === '.') {
        this.params.parcelId = nV.substr(14, nV.length);
      }
      this.isParcelTerritValid = { valid: true };
      this.$refs.form?.resetValidation();
    },
    updateParcelTerrit() {
      let territ = '';
      if (this.params.precinct && !this.$_isEmptyObject(this.params.precinct) && !this.params.precinctNotKnown) {
        territ += this.params.precinct.territId || '';
        if (this.params.parcelId) {
          territ += `.${this.params.parcelId}`;
        }
      } else if (this.params.community && !this.$_isEmptyObject(this.params.community)) {
        territ += this.params.community.territIdWithType || '';
        if (this.params.precinctNotKnown) {
          territ += '.?';
          if (this.params.parcelId) {
            territ += `.${this.params.parcelId}`;
          }
        }
      } else if (this.params.district && !this.$_isEmptyObject(this.params.district)) {
        territ += this.params.district.territId || '';
      } else if (this.params.voivodeship && !this.$_isEmptyObject(this.params.voivodeship)) {
        territ += this.params.voivodeship.territId || '';
      }
      this.parcelTerrit = territ;
      this.isParcelTerritValid = { valid: true };
    },
    async init(skipParamsClear = false) {
      this.menuOpenWatch();
      await this.getVoivodeships();
      const voivodeship = JSON.parse(localStorage.getItem('uldk2Voivodeship') || '{}');
      if (localStorage.getItem('uldk2Voivodeship')) {
        this.params = { ...this.params, voivodeship };
        await this.getDistricts(voivodeship, true, true, skipParamsClear);
        const district = JSON.parse(localStorage.getItem('uldk2District') || '{}');
        if (localStorage.getItem('uldk2District')) {
          this.params = { ...this.params, district };
          await this.getCommunities(district, true, true, skipParamsClear);
          let community = JSON.parse(localStorage.getItem('uldk2Community') || '{}');
          if (!Object.keys(community).includes('territIdWithType')) {
            // Fix for old structure (uldk) to new one (databox)
            const findCommunity = this.admnistrativeParamsItems.community[community.value];
            community = { ...findCommunity, ...community };
          }
          if (localStorage.getItem('uldk2Community')) {
            this.params = { ...this.params, community };
            await this.getPrecincts(community, true, true, skipParamsClear);
            if (localStorage.getItem('uldk2Precinct')) {
              const precinct = JSON.parse(localStorage.getItem('uldk2Precinct') || '{}');
              this.params = { ...this.params, precinct };
              this.$refs.form?.resetValidation();
              this.updateParcelTerrit();
            }
          }
        }
      }
      this.$watch(
        vm => vm.params,
        nV => {
          Object.entries({
            community: 'uldk2Community',
            voivodeship: 'uldk2Voivodeship',
            district: 'uldk2District',
            precinct: 'uldk2Precinct',
          }).forEach(([key, storageKey]) => {
            if (this.$_isEmptyObject(nV[key])) {
              this.$set(this.params, key, '');
            } else localStorage.setItem(storageKey, JSON.stringify(nV[key]));
          });
        },
        {
          deep: true,
          immediate: true,
        }
      );
    },
    async search(nV = this.parcelTerrit) {
      this.resultList = [];
      this.currentResult = undefined;
      this.loading = true;
      try {
        if (
          (nV.length >= 12 && nV.substring(8, 10) === '.?' && nV[10] === '.') ||
          (nV.length >= 15 && nV[13] === '.')
        ) {
          await this.searchParcel();
        } else if (nV.length >= 13 && !this.params.precinctNotKnown) {
          await this.searchPrecinct();
        } else if (nV.length >= 8) {
          await this.searchCommunity();
        } else if (nV.length >= 4) {
          await this.searchDistrict();
        } else if (nV.length >= 2) {
          await this.searchVoivodeship();
        } else {
          await this.searchParcel();
        }
      } finally {
        if (this.computedResultList.length === 1) this.currentResult = this.computedResultList[0];
        this.loading = false;
      }
    },
    async searchVoivodeship(nV = this.parcelTerrit) {
      const voivodeship = nV.substring(0, 2);
      const r = await this[`get${this.$_capitalize(this.mode)}Voivodeship`]({ voivodeship });
      if (r) this.resultList = [r];
    },
    async searchDistrict(nV = this.parcelTerrit) {
      const district = nV.substring(0, 4);
      const r = await this[`get${this.$_capitalize(this.mode)}District`]({ district });
      if (r) this.resultList = [r];
    },
    async searchCommunity(nV = this.parcelTerrit) {
      const community = nV.substring(0, 8);
      const r = await this[`get${this.$_capitalize(this.mode)}Community`]({ community: community.replaceAll('_', '') });
      if (r) this.resultList = [r];
    },
    async searchPrecinct(nV = this.parcelTerrit) {
      const precinct = nV.substring(0, 13);
      const r = await this[`get${this.$_capitalize(this.mode)}Precinct`]({ precinct });
      if (r) this.resultList = [r];
    },
    async searchParcel() {
      if (this.params.precinctNotKnown) {
        try {
          let resultList = [];
          const index = this.parcelTerrit.indexOf('.?');
          for await (const item of this.$_objectToArray(this.admnistrativeParamsItems.precinct)) {
            try {
              const territ = `${item.territId}${this.parcelTerrit.substring(index + 2)}`;
              const r = await this[`search${this.$_capitalize(this.mode)}Parcel`]({
                territ,
                geojsonLikeWithMapping: { teryt: 'id_dzialki' },
              });
              if (r) resultList.push(r);
            } catch (error) {
              switch (error.status) {
                case 404:
                  break;
                default: {
                  const errorMessage = `${error.status}: ${error.message}`;
                  return this.$store.set('snackbar/PUSH_ERROR!', {
                    message: errorMessage,
                  });
                }
              }
            }
          }
          if (resultList.length < 1) {
            this.$store.set('snackbar/PUSH_MESSAGE!', {
              message: this.$i18n.t('sidebar.uldk.noResults'),
            });
          } else {
            if (resultList.length > 1) {
              this.$store.set('snackbar/PUSH_MESSAGE!', {
                message: this.$i18n.t('sidebar.uldk.severalResultsFound'),
              });
            }
            this.resultList = resultList;
          }
        } finally {
          //
        }
      } else {
        try {
          const r = await this[`search${this.$_capitalize(this.mode)}Parcel`]({
            territ: this.parcelTerrit,
            geojsonLikeWithMapping: { teryt: 'id_dzialki' },
          });
          if (r) this.resultList = [r];
          else {
            return this.$store.set('snackbar/PUSH_MESSAGE!', {
              message: this.$i18n.t('snackbar.notFoundPlot'),
            });
          }
        } catch (error) {
          switch (error.status) {
            case 404: {
              return this.$store.set('snackbar/PUSH_MESSAGE!', {
                message: this.$i18n.t('snackbar.notFoundPlot'),
              });
            }
            default: {
              const errorMessage = `${error.status}: ${error.message}`;
              return this.$store.set('snackbar/PUSH_ERROR!', {
                message: errorMessage,
              });
            }
          }
        } finally {
          //
        }
      }
    },
    addParcel(geometry = this.currentResult?.geometry, parcelTerrit = this.currentResult?.parcelTerrit) {
      if (!geometry) return;
      this.$root.$emit('addUldkParcelToMap', geometry, parcelTerrit, {
        geometryType: this.modsGeometryTypeDict[this.mode],
        multiFeatures: true,
      });
      this.hasParcelsOnMap = true;
    },
    clear() {
      this.resultList = [];
      this.currentResult = undefined;
      this.$root.$emit('clearUldkParcel');
      this.hasParcelsOnMap = false;
    },
    toggleMultipleSearch() {
      this.multipleSearchVisible = !this.multipleSearchVisible;
      this.$nextTick(() => {
        if (this.multipleSearchVisible) this.isMenuOpen = false;
      });
    },
    getLocalizationListeners() {
      return this.$refs['geometry-input']?.$refs['data-input']?.computedListeners;
    },
    async getLocalizationByPoint(value) {
      const [x, y] = value.coordinates;
      let teryt;
      if (this.mode === 'uldk') {
        const r = await this.searchUldkParcelByXY({
          coords: { x, y, epsg: this.$_config.defaultEpsg.split(':')[1], params: ['teryt'] },
        });
        teryt = r.teryt;
      } else if (this.mode === 'databox') {
        const r = await this.searchDataboxParcelByXY({
          coordinates: [x, y],
        });
        teryt = r.data.properties.id_dzialki;
      }
      if (teryt) {
        this.parcelTerrit = teryt;
        this.changeParcelTerrit(teryt);
      }
      this.$refs['geometry-input']?.$refs['data-input']?.toggleOff();
    },
  },
  watch: {
    currentResult(nV) {
      if (nV) this.addParcel(nV.geometry, nV.parcelTerrit || nV.properties?.nazwa);
    },
    localizationPointGeometry: {
      handler(nV) {
        if (nV) this.getLocalizationByPoint(nV);
      },
      deep: true,
    },
  },
  mounted() {
    const mode = localStorage.getItem('uldk2Mode') || 'uldk';
    if (mode === 'databox' && !this.databoxEnabled) this.mode = 'uldk';
    else this.mode = mode;
    this.menuOpenWatch = this.$watch(
      vm => vm.isMenuOpen,
      nV => {
        if (nV) this.init();
      },
      { immediate: true }
    );
  },
};
</script>
<style lang="scss" scoped>
.background-icon {
  @include activeToolButtonStyle();
}
::v-deep {
  .active-icon * {
    color: map-get($colors, 'link') !important;
  }
  .v-input--selection-controls__input {
    margin-right: 2px !important;
  }
  .navbar-uldk-result-select {
    background-color: rgba(207, 207, 207, 0.25);
    .v-input__slot {
      min-height: 26px !important;
      padding: 0 6px !important;
      fieldset {
        border: unset !important;
      }
      .v-select__slot {
        font-size: 12px !important;
        padding-bottom: 1px !important;
        .v-select__selections {
          padding: unset !important;
        }
      }
    }
    .v-input__append-inner {
      margin-top: 2px !important;
    }
    .v-label {
      font-size: 14px;
      top: 7px !important;
    }
  }
  .v-input--checkbox {
    .v-input__slot {
      margin-bottom: unset !important;
      .v-label {
        font-size: 12px !important;
        color: unset !important;
      }
    }
    .v-messages {
      display: none !important;
    }
  }
  .v-input--selection-controls__input {
    margin-right: 2px !important;
  }
  .input--type {
    .v-icon {
      font-size: 18px;
    }
    .v-input--selection-controls__input {
      margin-right: 0;
    }
  }
  .uldk-inputs-databox {
    top: 7px;
    position: relative;
  }
}
</style>
